import { z } from "zod";
export const ValidationErrorResponse = z.object({
    error: z.literal("validation_failed"),
    issues: z.array(z.object({
        path: z.array(z.union([z.string(), z.number()])),
        message: z.string(),
    })),
});
export const NotFoundResponse = z.object({ error: z.string() });
export const ForbiddenResponse = z.object({ error: z.string() });
export const BadRequestResponse = z.object({ error: z.string() });
export const GatewayErrorResponse = z.object({ error: z.string() });
export const OkResponse = z.object({ status: z.literal("ok") });
//# sourceMappingURL=errors.js.map